module.exports = {
  convertPayrollDataToCSV: grid => {
    return [
      [
        'Period_End_Date',
        'Placement_ID',
        'Description',
        'Earn_Code',
        'Transaction_Date',
        'Amount',
        'Qty',
        'Pay_Rate',
        'Billing_Rate',

        'WAE_Placement_ID',

        'WAE_Candidate_ID',
        'WAE_Candidate_Name',

        'WAE_Corporation_ID',
        'WAE_Corporation_Name',

        'WAE_Timecard_Status',
        'WAE_Timecard_Imbalanced',
      ],
    ]
      .concat(grid)
      .map(row => row.join(','))
      .join('\n');
  },
};
